// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2ozdm";
var _4 = "header-1rBvE";
var _5 = "header__text-1rPbG";
var _6 = "closeButton-zpQKG";
var _7 = "flight-2_Xpc";
var _8 = "flight__direction-3WIDg";
var _9 = "passenger-2eWGx";
var _a = "notification-2oMJx";
var _b = "notification__title-4BJVm";
var _c = "buttons-zE3Zi";
var _d = "newSearch-29yPz";
var _e = "continueButton-1UBHH";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "header", _5 as "header__text", _6 as "closeButton", _7 as "flight", _8 as "flight__direction", _9 as "passenger", _a as "notification", _b as "notification__title", _c as "buttons", _d as "newSearch", _e as "continueButton" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "header": _4, "header__text": _5, "closeButton": _6, "flight": _7, "flight__direction": _8, "passenger": _9, "notification": _a, "notification__title": _b, "buttons": _c, "newSearch": _d, "continueButton": _e }
